import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineL } from '#src/atoms/typography/index.tsx';

const Content = styled(Vertical).attrs({ gap: 2 })`
  height: 100%;
`;

const List = styled.ul`
  padding-left: var(--double-unit);
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  margin: 0;

  li {
    list-style-type: disc;
  }
`;

export const MangopayConsentIntro = () => {
  return (
    <Content>
      <HeadlineL as="h3">
        <FormattedMessage
          id="createFiatWallet.MangopayConsentIntro.title"
          defaultMessage="Authorize Sorare to manage your fiat wallet"
        />
      </HeadlineL>
      <List>
        <li>
          <BodyM>
            <FormattedMessage
              id="createFiatWallet.MangopayConsentIntro.description.authorizeManageFiatWallet"
              defaultMessage="You need to authorize Sorare to manage your fiat wallet to keep your transactions secure and protect your account."
            />
          </BodyM>
        </li>
        <li>
          <BodyM>
            <FormattedMessage
              id="createFiatWallet.MangopayConsentIntro.description.processPaymentsSmoothly"
              defaultMessage="This allows us to process your payments more smoothly, without asking you to confirm every single step."
            />
          </BodyM>
        </li>
      </List>
    </Content>
  );
};
